import { useEffect, useState } from "react";
import {
	formatWebinarCountdown,
	secondsUntilWebinarStart,
	webinarHeroStatusKind,
	webinarHeroStatusLabel,
} from "./webinarHeroStatus";

export default function WebinarHeroStatusBadge({ startDatetime }) {
	const [kind, setKind] = useState(() => webinarHeroStatusKind(startDatetime));
	const [countdownSeconds, setCountdownSeconds] = useState(() =>
		secondsUntilWebinarStart(startDatetime),
	);

	useEffect(() => {
		const sync = () => {
			setKind(webinarHeroStatusKind(startDatetime));
			setCountdownSeconds(secondsUntilWebinarStart(startDatetime));
		};
		sync();
		const interval = setInterval(sync, 1000);
		return () => clearInterval(interval);
	}, [startDatetime]);

	if (kind === "none") {
		return null;
	}

	let text = webinarHeroStatusLabel(kind);
	if (kind === "countdown") {
		text = formatWebinarCountdown(countdownSeconds);
	}
	if (!text) {
		return null;
	}

	return (
		<span className="absolute left-3 top-3 z-10 max-w-[85%] rounded-lg bg-darkBlue/85 px-3 py-1.5 font-Vazir-600 text-[11px] text-white md:text-[12px]">
			{text}
		</span>
	);
}
